import { watch } from 'vue';
import { i18n } from '@/plugins/i18n';

/**
 * Keeps <html lang> attribute in sync with the current i18n locale.
 * Important for accessibility (screen readers) and SEO (Google lang detection).
 */
export function useSyncHtmlLang(): void {
  if (typeof document === 'undefined') return;

  // Set initial value
  document.documentElement.lang = i18n.global.locale.value;

  // Watch for changes
  watch(
    () => i18n.global.locale.value,
    (newLocale) => {
      document.documentElement.lang = newLocale;
    },
  );
}
